import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {ErrorBoundary} from 'react-error-boundary'
import Main from './componentes/Main';

/*
ReactDOM.render(
  //<React.StrictMode>
    <App />,
  //</React.StrictMode>,
  document.getElementById('root')
);
*/


  ReactDOM.render(
    //<React.StrictMode>
    <ErrorBoundary FallbackComponent={ErrorFallback}>
        <App />
    </ErrorBoundary>,
    //</React.StrictMode>,
    document.getElementById('root')
  );



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

function ErrorFallback({error, resetErrorBoundary}) {
  return (
    <Main center>
      <div className="text-center">
          <p>{error.message}</p>
      </div>
    </Main>
  )
}